<template>
  <div id="app">
    <router-view />
    <!--验证码弹窗-->
    <el-dialog title="请完成校验" :visible.sync="txjymShowLocal" width="420px" @close="txjymlose">
      <div>
        <p>该账号有异常操作，可能存在风险，需进行身份验证：</p>
        <p style="color:red">提示：验证完成后若又出现该弹窗，请清除浏览器缓存（一般可使用shift+f5）</p>
      </div>
      <div>
        <img style="cursor: pointer" :src="webValidUrl" @click = "getwebValidJym"/>
        <el-input v-model="webValidCode" placeholder="请输入图形校验码"></el-input>
      </div>
      <div style="text-align: center;margin-top:20px;">
        <el-button
          size="small"
          @click="txjymlose()"
        >取 消</el-button>
        <el-button
          size="small"
          style="
            background-color: #0f70ff;
            border-color: #0f70ff;
            margin-left: 30px;
          "
          type="primary"
          @click="webValidSave"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getCookieToken, isEmpty } from '@/utils/tool'
import {checkValidTxjym} from "@/assets/js/system";
import store from '@/store'
import {getVerifyCode} from "@/assets/js/login";

export default {
  name: 'Home',
  components: {},
  data() {
    return {
      txjymShowLocal: false,
      webValidUrl: '',
      webValidUuid: '',
      webValidCode: ''
    }
  },
  watch: {
    '$store.state.txjymShow': {
      handler(newVal, oldVal) {
        // eslint-disable-next-line eqeqeq
        if (newVal == true) {
          this.txjymShowLocal = true
          this.getwebValidJym()
        }
      }
    }
  },
  created() {
    document.addEventListener('visibilitychange', function() {
      const token = getCookieToken()
      if (isEmpty(token)) {
        if (!isEmpty(store.state.token)) {
          sessionStorage.setItem('refresh', '1')
          location.reload()
        }
      } else {
        if (!isEmpty(store.state.token) && store.state.token != token) {
          sessionStorage.setItem('refresh', '1')
          location.reload()
        }
      }
    })
  },
  methods: {
    webValidSave() {
      if (isEmpty(this.webValidCode)) {
        this.$message.error('请输入验证码!')
        return
      }
      checkValidTxjym({ code: this.webValidCode, uuid: this.webValidUuid }).then((e)=> {
        this.txjymShowLocal = false
        this.$store.state.txjymShow = false
        this.$router.go(0)
      }).catch((e) => {
        // eslint-disable-next-line eqeqeq
        if (e.response.data.code == '010137') { // 非校验不通过错误，关闭图形校验码弹窗
           this.getwebValidJym()
        }
      })
    },
    txjymlose() {
      this.$message.error('请进行身份验证，否则无法操作业务功能!')
      this.txjymShowLocal = false
      this.$store.state.txjymShow = false
      this.webValidUuid = ''
      this.webValidUrl = ''
      this.webValidCode = ''
    },
    getwebValidJym() {
      // 请求后台获取校验码
      getVerifyCode().then((e) => {
        this.webValidUuid = e.data.data.uuid
        this.webValidUrl = e.data.data.img
      }).catch(() => {
        this.webValidUuid = ''
        this.webValidUrl = ''
      })
    },
  }
}
</script>
<style>
body {
  margin: 0;
  padding: 0;
  color: #333333;
}
#app {
  height: 100vh;
}
* {
  box-sizing: border-box;
}
._body {
  display: flex;
  flex-direction: column;
  height: 100vh;
  color: #333333;
}
._sidemenu {
  height: 100%;
  width: 17vw;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
}
._page {
  display: flex;
  flex-grow: 1;
  flex-shrink: 1;
  height: 0;
  overflow: auto;
  background-color: #eef1f9;
}
._content {
  flex-grow: 1;
  flex-shrink: 1;
  height: 100%;
  overflow-y: auto;
  width: 0;
}
/*修改滚动条样式*/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
::-webkit-scrollbar-thumb {
  background: #d6d6d6;
  border-radius: 10px;
}
/* 适配 */
/* @media (min-width: 1280px) {
    ._sidemenu{
        width: 222px;
      }
  }
  @media (min-width: 1366px) {
    ._sidemenu{
        width: 247px;
      }
  }
  @media (min-width: 1440px) {
    ._sidemenu{
        width: 272px;
      }
  }
  @media (min-width: 1680px) {
    ._sidemenu{
        width: 297px;
      }
  }
  @media (min-width: 1920px) {
      ._sidemenu{
        width: 322px;
      }
  } */
.quedingActive {
  color: #fff !important;
  background-color: #5377ff !important;
  border-color: #5377ff !important;
}
.el-input.is-disabled .el-input__inner {
  color: #333333 !important;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #333333 !important;
}
.el-range-input {
  color: #333333 !important;
}
.required::before {
  content: "*";
  color: #F56C6C;
  margin-right: 4px;
}
</style>
